import React from 'react'
import { PropTypes } from 'prop-types'
import { flowRight } from 'lodash'
import { graphql } from '@apollo/client/react/hoc'
import { withRouter } from 'react-router-dom'
import { graphqlCurrentUserCached } from 'lib/utils/store/currentUser'

import ActionLogic from 'components/Util/ActionLogic'

import updateVehicleStatus from 'graphql/vehicle/updateVehicleStatus.gql'
import getVehicleProfileView from 'graphql/view/getVehicleProfileView.gql'

class AdStatusLogic extends React.Component {
    setAdStatus = async (actionLogic, vehicleId, adStatus, statusInfo) => {
        const { currentUser } = this.props

        actionLogic.asyncSetState({
            error: false,
            loading: true,
        })

        return this.props.updateVehicleStatus({
            variables: {
                vehicleId: vehicleId,
                status: adStatus,
                soldInfo: statusInfo,
            },
            refetchQueries: [{
                query: getVehicleProfileView,
                variables: {
                    vehicleId: vehicleId,
                    userId: currentUser.me.id,
                }
            }],
            awaitRefetchQueries: true,
        }).then((result) => {
            actionLogic.asyncSetState({
                error: false,
                loading: false,
            })

            return Promise.resolve(result)
        }).catch((e) => {
            actionLogic.asyncSetState({
                error: e,
                loading: false,
            })

            return Promise.reject(e)
        })
    }

    actions = {
        setAdStatus: this.setAdStatus,
    }

    render () {
        return (
            <ActionLogic>
                {(actionLogic) => (
                    this.props.children({
                        ...actionLogic,
                        setAdStatus: (...args) => this.setAdStatus(actionLogic, ...args),
                    })
                )}
            </ActionLogic>
        )
    }
}

AdStatusLogic.propTypes = {
    children: PropTypes.func.isRequired,
}

export default flowRight(
    withRouter,
    graphqlCurrentUserCached,
    graphql(updateVehicleStatus, { name: 'updateVehicleStatus' }),
)(AdStatusLogic)
